import { ChecklistTargetType } from 'constants/checklists';

import { CHECKLISTS_ACTION_TYPE } from '../actions';

const emptyTargetSchema = {};

const initialState = {
  [ChecklistTargetType.LOAN]: emptyTargetSchema,
  [ChecklistTargetType.COMPANY]: emptyTargetSchema,
};

// The fetching company is stamped alongside the schema: native impersonation soft-navigates without a
// MASTER_LOGGED_OUT store reset, so the slice can otherwise outlive the company it was fetched for.
const setTargetSchema = (state, { targetType, companyId, key, payload }) => {
  // The whole slice drops on a company change, not just the target type being written: the sibling type would
  // otherwise keep the previous company's catalog under the new company's stamp.
  const base = state.companyId === companyId ? state : initialState;

  return {
    ...base,
    companyId,
    [targetType]: {
      ...base[targetType],
      [key]: payload || emptyTargetSchema,
    },
  };
};

const checklistsSchemaReducer = (state = initialState, { type, payload, meta }) => {
  const targetType = meta?.targetType || ChecklistTargetType.LOAN;

  switch (type) {
    case CHECKLISTS_ACTION_TYPE.GET_CHECKLISTS_SCHEMA:
      return setTargetSchema(state, {
        targetType,
        companyId: meta?.companyId,
        key: 'resultSchema',
        payload,
      });

    case CHECKLISTS_ACTION_TYPE.GET_CHECKLISTS_VISIBILITY_SCHEMA:
      return setTargetSchema(state, {
        targetType,
        companyId: meta?.companyId,
        key: 'visibilitySchema',
        payload,
      });

    default:
      return state;
  }
};

export default checklistsSchemaReducer;
